
import React, { Component } from 'react';
import { Modal, Button } from 'antd';

import {cityPostal} from "../../../util/cityPostal";

class ApplicationPrint extends Component {

    print = () => {
        var printHtml = window.document.getElementById('deal_detail_print_div').innerHTML;
        var newWindow = window.open("", "print");
        newWindow.document.body.innerHTML = printHtml;
        newWindow.window.print();
        newWindow.window.close();
        //打印完成关闭窗口
        this.props.onCancel();
    };

    render() {
        const { visible, onCancel, printData } = this.props;
        if(printData["agency"] === "91350200260066698P"){
            printData["agencyName"] ="";
            printData["agentTel"] ="";
        }
        return (
            <Modal
                width={800}
                visible={visible}
                title="打印申请表"
                okText="打印"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.print}
                footer={[
                    <Button key="cancel" onClick={onCancel}>取消</Button>,
                    // <Button key="edit" type="primary" onClick={()=>this.props.editFunc(printData.applicationId)}>修改</Button>,
                    <Button key="print" type="primary" onClick={this.print}>打印</Button>,
                ]}
            >
                <div id="deal_detail_print_div">
                    <style>
                        {
                            `
                            .print_div{font-family:'SimSun'; font-size:13px; font-weight: bold; text-align: center;width:696px;margin:0 auto;}
                            .print_div td{border:1px solid #000;  height:60px; padding:0; text-align: center;font-size:13px;font-weight: bold;}
                            .value_text{font-size: 16px; font-weight: bold;}
                            .value_text.on{
                                font-size: 13px;
                            }
                            @media print {
                                #printBtn{display: none;}
                            }
                            .noborder_box{
                                textAlign: left;
                                borderBottom: none;
                                padding: 0;
                                height: 218px
                            }
                            .noborder{border:none;border-collapse:collapse;}
                            .noborder td{border:none; text-align: left;padding:10px 0;height:0;}
                            .title{
                                width: 100%; 
                                padding: 0px 0 21px 0;
                            }
                            .reply_title{
                                padding: 0;
                                height: 55px;
                            }
                            .reply_box{
                                textAlign: left; 
                                textIndent: 5; 
                                borderBottom: none; 
                                padding: 0; 
                                height: 122px;
                            }
                            .span_txt{
                                font-family: "SimHei";
                                font-size: 18px;
                                font-weight: bold;
                            }
                            .roll_out.print_div td{
                                height: 60px;
                                font-weight: normal;
                            }
                            .roll_out .title{
                                padding: 10px 0;
                            }
                            .roll_out .reply_box{
                                height: auto;
                            }
                            .roll_out .reply_box .noborder td{
                                height: 34px;
                                padding: 12px 0;
                            }
                            .roll_out .noborder_box{
                                height: auto;
                            }
                            .roll_out .noborder td{
                                padding: 0;
                                height: 37px;
                            }
                            .roll_out.print_div td.reply_title{
                                height: 35px;
                            }
                            .roll_out.print_div td.reply_title.on{
                                height: 60px;
                            }
                            .roll_out .small_td td{
                                height: 60px;
                            }
                            .roll_out .span_txt{
                                font-weight: normal;

                            }
                            .roll_out .noborder .last_tr td{
                                height: auto;

                            }
                            td.foot_txt{
                                padding: 0 10px 0 10px;
                            }
                            .roll_out td.foot_txt{
                                padding-right: 0;
                            }
                            .roll_out .noborder .pt16 td{
                                padding-top: 16px;
                            }
                            .roll_out .noborder .pt17 td{
                                padding-top: 6px;
                            }
                        `
                        }
                    </style>
                    <div className={['print_div', printData['transferType'] === 2 ||   printData['transferType'] === "2" ? 'roll_out' : ''].join(' ')}>
                        <div className="title">
                            <span style={{ fontSize: 26, fontWeight: 'bold' }}>机动车注册、转移、注销登记/转入申请表</span>
                        </div>
                        <table style={{ border: '2px solid #000', borderBottomWidth: 1, width: '100%', borderCollapse: 'collapse' }}>
                            <tbody>
                                <tr>
                                    <td colSpan={6} className="reply_title">
                                        <span style={{ fontSize: 18, fontWeight: 'bold' }}>申请人信息栏</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan={3} style={{ width: 50 }}><span>机<br />动<br />车<br />所<br />有<br />人</span></td>
                                    <td style={{ width: 145 }}><span>姓名/名称</span></td>
                                    <td colSpan={2}>
                                        <span className="value_text" >{printData["buyerName"]}</span>
                                    </td>
                                    <td style={{ width: 80 }}><span>邮政编码</span></td>
                                    <td style={{ width: 129, fontWeight: 'bold' }}>
                                        <span className="value_text">{cityPostal[printData["destination"]]}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span>邮寄地址</span></td>
                                    <td colSpan={4} style={{ textAlign: 'left' }}>
                                        <span className="value_text" style={{ "paddingLeft": 15 }}>{printData["buyerResidenceAddress"]}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span>手机号码</span></td>
                                    <td colSpan={2}>
                                        <span className="value_text" >{printData["buyerTel"]}</span>
                                    </td>
                                    <td><span>固定电话</span></td>
                                    <td>
                                        <span className="value_text" />
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: 0 }}><span>代<br />理<br />人</span></td>
                                    <td><span>姓名/名称</span></td>
                                    <td style={{ width: 196 }}>
                                        <span className="value_text on">{printData["agencyName"]}</span>
                                    </td>
                                    <td style={{ width: 100 }}><span>手机号码</span></td>
                                    <td colSpan={2}>
                                        <span className="value_text">{printData["agentTel"]}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table style={{ border: '1px solid #000', borderWidth: '0 2px', width: '100%', borderCollapse: 'collapse' }}>
                            <tbody>
                                <tr>
                                    <td colSpan={5} className="reply_title on">
                                        <span style={{ fontSize: 18, fontWeight: 'bold' }}>申请业务事项</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}><span>申请事项</span></td>
                                    <td colSpan={3} className="reply_box">
                                        <table style={{ width: '100%' }} className="noborder">
                                            <tbody><tr className="pt16">
                                                <td style={{ width: 120 }}>□注册登记</td>
                                                <td style={{ width: 120 }}>□转让登记</td>
                                                <td style={{ width: 120 }}>□注销登记</td>
                                                <td style={{ width: 120 }}>□车辆转入</td>
                                                <td style={{ width: 200 }}>□抵押/质押期间办理</td>
                                            </tr>
                                            <tr className="pt17">
                                                <td colSpan={3} style={{width: 360}}>□待销售二手车（ □核发临牌 □核发号牌 ）</td>
                                            </tr>
                                                <tr>
                                                    <td >□车辆转出</td>
                                                    <td  style={{ textAlign: 'right' }}>转出至：</td>
                                                    <td  colSpan={2} style={{ textAlign: 'right' }}>省(自治区、直辖市)</td>
                                                    <td  style={{ textAlign: 'right',paddingRight:30 }}>市（地、州）</td>
                                                </tr>
                                            </tbody></table>
                                    </td>
                                </tr>
                                <tr className="small_td">
                                    <td colSpan={2}><span>号牌种类</span></td>
                                    <td style={{ width: 200 }}>
                                        <span className="value_text" id="vehicleType" >{printData["plateType"]}</span>
                                    </td>
                                    <td style={{ width: 150 }}><span>号牌号码</span></td>
                                    <td style={{ width: 200 }}>
                                        <span className="value_text" id="licensePlate" >{printData["plateNo"]}</span>
                                    </td>
                                </tr>
                                <tr className="small_td">
                                    <td colSpan={2}><span >申请使用<br />原号牌号码</span></td>
                                    <td>
                                        <span className="value_text" id="vehicleType" >□是&nbsp;&nbsp;&nbsp;&nbsp;□否</span>
                                    </td>
                                    <td><span>原号牌号码</span></td>
                                    <td>
                                        <span className="value_text" ></span>
                                    </td>
                                </tr>
                                <tr className="small_td">
                                    <td rowSpan={2} style={{ width: 27, borderBottomWidth: 0 }}>
                                        <span>机<br />动<br />车</span>
                                    </td>
                                    <td style={{ width: 90 }}><span>品牌型号</span></td>
                                    <td style={{ width: 212 }}>
                                        <span className="value_text" id="vehicleBrand" >
                                            {printData["brandModel"]}
                                        </span>
                                    </td>
                                    <td ><span>使用性质</span></td>
                                    <td colSpan={2} className="noborder_box" >
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: 90 }}>
                                        <span>车辆识别代号</span>
                                    </td>
                                    <td colSpan={3} style={{ width: 209 }}>
                                        <span className="value_text" id="vin" >{printData["vin"]}</span>
                                    </td>
                                </tr>

                                <tr className="small_td">
                                    <td colSpan={2}><span >注销情形</span></td>
                                    <td colSpan={2}>
                                    </td>
                                    <td style={{textAlign: 'left'}}>
                                        <span >注：机动车因灭失注销的，应提交机动车灭失书面承诺</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <table style={{ border: '2px solid #000', width: '100%', borderCollapse: 'collapse' }}>
                            <tbody>
                                <tr>
                                    <td rowSpan={3} className="foot_txt" style={{ width: 260, textAlign: 'right', borderRightWidth: 2 }}>
                                        <span className="span_txt">
                                            <span/>申请人对申请材料实质内容的<br/>真实性以及机动车的合法性负责。
                                        </span>
                                    </td>
                                    <td style={{ width: 350, textAlign: 'left', padding: '15px 5px', borderBottom: 'none' }}>
                                        <span>机动车所有人（代理人）签字：</span><br/><br/><br/>
                                        <span>原机动车所有人（代理人）签字：</span><br/><br/><br/>
                                        <span>抵押权人/质权人（代理人）签字：</span>
                                    </td>
                                </tr>
                                {/* <tr>
                                    <td style={{ border: 'none', height: 33 }}>
                                    </td>
                                </tr> */}
                                <tr>
                                    <td style={{ textAlign: 'right', padding: '16px 5px', borderTop: 'none',borderBottom: '2px solid #000', height: 0 }}>
                                        <span>年&nbsp;&nbsp;月&nbsp;&nbsp;日</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        );
    }
}


export default ApplicationPrint;